import { TreeSelectProps } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import DimensionTreeSelectWithRoot from './DimensionTreeSelectWithRoot'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'

const CtxDimensionTreeSelectWithRoot = (props: TreeSelectProps) => {
  const companyId = useSelector(contextCompanyIdSelector)
  return <DimensionTreeSelectWithRoot {...props} companyId={companyId} />
}

export default CtxDimensionTreeSelectWithRoot
